export default `/* Ids Virtual Scroll Component */
:host {
  display: flex;
  width: 100%;
  height: 100dvh;
}

:host([hidden]) {
  display: none;
}

.ids-virtual-scroll {
  display: grid;
  grid-auto-flow: column;
  width: 100%;
}
.ids-virtual-scroll:focus {
  outline: 0;
  justify-self: end;
}

.ids-virtual-scroll-content {
  position: relative;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdmlydHVhbC1zY3JvbGwiLCJzb3VyY2VzIjpbImlkcy12aXJ0dWFsLXNjcm9sbC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBRUE7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7O0FBSUo7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBWaXJ0dWFsIFNjcm9sbCBDb21wb25lbnQgKi9cblxuOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDBkdmg7XG59XG5cbjpob3N0KFtoaWRkZW5dKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbi5pZHMtdmlydHVhbC1zY3JvbGwge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLWF1dG8tZmxvdzogY29sdW1uO1xuICB3aWR0aDogMTAwJTtcblxuICAmOmZvY3VzIHtcbiAgICBvdXRsaW5lOiAwO1xuICAgIGp1c3RpZnktc2VsZjogZW5kO1xuICB9XG59XG5cbi5pZHMtdmlydHVhbC1zY3JvbGwtY29udGVudCB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cbiJdfQ== */`;
